$(window).ready(function() {
    // Function to calculate and set header height
    // function setHeaderHeight() {
    //     var windowHeight = $(window).height();
    //     var headerHeight = $('header').outerHeight(true); // Check if this includes margins
    //     var newHeaderHeight = windowHeight - headerHeight;
    //     $('.bodyWrap').css('padding-top', headerHeight);

    //     console.log("Window height:", windowHeight);
    //     console.log("Header height:", headerHeight);
    // }

    // // Call the function on window load and on window resize
    // setHeaderHeight();
    // $(window).resize(setHeaderHeight);
  //   $('.pdp_Checkout').click(function(e){
  //   // e.preventDefault();
  // });

  $('a[href^="#looxReviews"]').on('click', function (e) {
    e.preventDefault();

    var targetElement = document.getElementById('looxReviews');
    
    if (targetElement) {
        // Get the top position of the target element relative to the document
        var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

        // Determine the header height based on screen width
        var headerHeight = window.innerWidth <= 768 ? 131 : 180; // Adjust the breakpoint if necessary

        window.scrollTo({
            top: targetPosition - headerHeight,
            behavior: 'smooth'
        });
    }
});
});

